const apiUrl = process.env.NODE_ENV === "development"
  ? "http://localhost:8080"
  : process.env.REACT_APP_API_URL;

export async function customFetch(path, options = {}) {
  const token = localStorage.getItem("token");
  const method = options.method ? options.method.toUpperCase() : "GET";
  const skipAuth = options.skipAuth || false;

  const headers = {
    ...options.headers,
  };

  if (!skipAuth && token) {
    headers["Authorization"] = `Bearer ${token}`;
  }

  const config = {
    method,
    headers,
    credentials: "include",
    body: options.body ? JSON.stringify(options.body) : undefined,
  };

  let res;

  const isLocal =
    path.startsWith("http://localhost:8080") ||
    path.startsWith(process.env.REACT_APP_API_URL) ||
    path.startsWith("/");

  res = await fetch(`${isLocal ? apiUrl : ""}${path}`, config);

  if (!res.ok) {
    const errorData = await res.json();
    throw new Error(errorData.error || 'Error en la llamada API');
  }

  return res.json();
}

export async function getFormApi(path) {
  let response;

  const isLocal =
    path.startsWith("http://localhost:8080/") ||
    path.startsWith(process.env.REACT_APP_API_URL) ||
    path.startsWith("/");

  if (isLocal) {
    const res = await fetch(path);
    if (!res.ok) throw new Error(`${res.status} ${res.statusText}`);
    response = await res.json();
  } else {
    response  = await customFetch("/api/fetch-json", {
      method : "POST",
      headers: { "Content-Type": "application/json" },
      body   : { url: path }
    });
  }

  if (response.type == "object" || response.properties || response.jsonSchema)
    return response

  throw new Error("La URL no contiene un JSON-Schema válido");
}